import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledTooltip = styled.div`
  position: relative;
  display: inline-flex;
`;

export const StyledTooltipToggler = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const StyledTooltipMessage = styled.div`
  position: fixed;
  z-index: 101;
  visibility: hidden;
  opacity: 0;
  padding: 12px;
  border-width: 1px;
  border-style: solid;
  transition: opacity 0.3s ease-out;
  text-decoration: none;
  text-transform: none;
  text-align: center;
  border-color: ${themeGet('colors.tooltip.borderColor')};
  background-color: ${themeGet('colors.white')};
  border-radius: ${themeGet('radii.base')};
  color: ${themeGet('colors.tooltip.color')};
  font-size: ${themeGet('fontSizes.xs')}px;
  line-height: 14px;
  white-space: nowrap;

  &.show {
    opacity: 1;
    visibility: visible;
  }

  &.type-default {
    font-weight: ${themeGet('fontWeights.base')};

    &::before {
      border-top: 8px solid ${themeGet('colors.tooltip.borderColor')};
    }
  }

  &.type-error {
    font-weight: ${themeGet('fontWeights.semi')};
    border-color: ${themeGet('colors.input.textError')};
    color: ${themeGet('colors.input.textError')};

    &::before {
      border-top: 8px solid ${themeGet('colors.input.textError')};
    }
  }

  &.type-info {
    padding: 7px;
    border-width: 2px;
    line-height: 14px;
    border-color: ${themeGet('colors.tooltip.color')};
    font-size: ${themeGet('fontSizes.xxs')}px;

    .multi-line {
      text-align: left;
    }

    &::before {
      border-top: 8px solid ${themeGet('colors.tooltip.color')};
    }
  }

  .multi-line {
    display: block;
    white-space: nowrap;
    text-align: center;
  }

  &::before,
  &::after {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
  }

  &::before {
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 8px solid ${themeGet('colors.tooltip.borderColor')};
    bottom: -8px;
    left: 50%;
    margin-left: -10px;
  }

  &::after {
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top-color: #fff;
    border-top-style: solid;
    border-top-width: 6px;
    bottom: -6px;
    left: 50%;
    margin-left: -8px;
  }

  &.place-top {
    margin-top: -10px;
  }
`;
